import { useTranslation } from "react-i18next";
import { Page } from "../../../../components/Page";
import { WithAuthorization } from "../../../../context";
import { useState } from "react";
import { Center, Flex, Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import { Card } from "../../../../components/Card";
import { ClimateActionDescription, ClimateActionGraphic, ClimateActionPolicyOverview } from "./components";
import ukFlag from "../../../../assets/flags/gb.png";
import germanyFlag from "../../../../assets/flags/de.png";
import euFlag from "../../../../assets/flags/eu.png";
import usaFlag from "../../../../assets/flags/us.png";
import { CountrySelector } from "../index";
import { euData, germanyData, ukData, usaData } from "./components/helpers";

function ClimateActionTracker() {
  const countryOptions = [
    { name: "UK", flag: ukFlag, data: ukData },
    { name: "Germany", flag: germanyFlag, data: germanyData },
    { name: "EU", flag: euFlag, data: euData },
    { name: "USA", flag: usaFlag, data: usaData }
  ];
  const { t } = useTranslation("translation", {
    keyPrefix: "climateActionTracker"
  });
  const [tabIndex, setTabIndex] = useState(0);
  const [selectedCountry, setSelectedCountry] = useState(countryOptions[0]);

  const handleCountryChange = (value) => {
    setSelectedCountry(countryOptions.find(el => el.name === value));
  };

  return (
    <Page title={t("page.title")} subTitle={t("page.subTitle")}>
      <Flex justifyContent="center" marginTop={5}>
        <CountrySelector
          data={countryOptions}
          selectedValue={selectedCountry}
          handleCountryChange={handleCountryChange}
        />
      </Flex>
      <Card marginBlockStart={5}>
        <Tabs colorScheme="customScheme" index={tabIndex} onChange={setTabIndex} overflow="auto">
          <Center>
            <TabList borderBottom="none" overflow="auto">
              <Tab mb={0} _focus={{ boxShadow: "none" }}>{t("tabs.description")}</Tab>
              <Tab mb={0} _focus={{ boxShadow: "none" }}>{t("tabs.graphic")}</Tab>
              <Tab mb={0} _focus={{ boxShadow: "none" }}>{t("tabs.policyOverview")}</Tab>
            </TabList>
          </Center>
          <TabPanels>
            <TabPanel padding="0">
              <ClimateActionDescription />
            </TabPanel>
            <TabPanel padding="0">
              <ClimateActionGraphic data={selectedCountry.data} />
            </TabPanel>
            <TabPanel padding="0">
              <ClimateActionPolicyOverview data={selectedCountry.data} />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Card>
    </Page>
  );
}

export default WithAuthorization(ClimateActionTracker);